import React, { useState } from 'react';
import { ImageIcon, TagIcon } from 'lucide-react';
import { useDarkMode } from '../../context/DarkModeContext';
import GraphicsLightbox from '../../components/Graphics/GraphicsLightbox';
type GalleryFilter = 'posted' | 'tagged';
export const GraphicsTab = ({
  authorId,
  authorName,
  graphics,
  books
}: any) => {
  const [selectedGraphic, setSelectedGraphic] = useState<any>(null);
  const [filter, setFilter] = useState<GalleryFilter>('posted');
  const {
    darkMode
  } = useDarkMode();
  const safeGraphics = Array.isArray(graphics) ? graphics : [];
  // Filter by postType; graphics without postType default to 'posted'
  const filteredGraphics = safeGraphics.filter((g: any) => (g.postType ?? 'posted') === filter);
  return <div className="space-y-8" data-id="element-7111" data-mp="3re63amr6jor7">
      <div className={`p-6 rounded-2xl ${darkMode ? 'bg-gray-800/50' : 'bg-white border border-gray-100 shadow-sm'}`} data-id="element-7112" data-mp="33q53c282hgne">
        {/* Header row with filter toggle */}
        <div className="flex items-center justify-between mb-4" data-id="element-7113" data-mp="2zmgtfcvyq8yz">
          <h3 className={`text-lg font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-7114" data-mp="9eav9yhdxra3">
            Gallery
          </h3>
          <div className={`flex rounded-xl p-1 gap-1 ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`} data-id="element-7115" data-mp="j4vr5e5ochpb">
            {(['posted', 'tagged'] as GalleryFilter[]).map(f => <button key={f} onClick={() => setFilter(f)} className={`flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium transition-all ${filter === f ? darkMode ? 'bg-gray-600 text-white shadow-sm' : 'bg-white text-gray-900 shadow-sm' : darkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-7116" data-mp="o5tb9wa8vltg">
                {f === 'tagged' && <TagIcon className="w-3.5 h-3.5" data-id="element-7117" data-mp="1bucgg2xzzihb" />}
                {f === 'posted' ? 'My Posts' : 'Tagged In'}
              </button>)}
          </div>
        </div>

        {filteredGraphics.length === 0 ? <div className={`flex flex-col items-center justify-center py-16 rounded-xl border-2 border-dashed ${darkMode ? 'border-gray-700 text-gray-500' : 'border-gray-200 text-gray-400'}`} data-id="element-7118" data-mp="3cuhcrq680vgv">
            <ImageIcon className="h-12 w-12 mb-3 opacity-40" data-id="element-7119" data-mp="3lvnx6abzqqfe" />
            <p className="text-base font-medium mb-1" data-id="element-7120" data-mp="3hulx5ra92acd">No images yet</p>
            <p className="text-sm opacity-70" data-id="element-7121" data-mp="2u5asvztoxxth">
              {filter === 'posted' ? 'Images you post will appear here.' : "Images you're tagged in will appear here."}
            </p>
          </div> : <div className="columns-2 sm:columns-3 lg:columns-4 gap-3" data-id="element-7122" data-mp="32yecyqyud8x3">
            {filteredGraphics.map((graphic: any) => <div key={graphic.id} className={`break-inside-avoid mb-3 group relative rounded-xl overflow-hidden cursor-pointer ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`} onClick={() => setSelectedGraphic(graphic)} data-id="element-7123" data-mp="2y5l4bs095gfq">
                <img src={graphic.imageUrl} alt={graphic.title} className="w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-7124" data-mp="1wa73kgqndj10" />
                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center" data-id="element-7125" data-mp="1mbhlonyr3ykr">
                  <div className="text-white text-center p-4" data-id="element-7126" data-mp="2f3ays6jik3xq">
                    <p className="font-bold text-lg mb-1" data-id="element-7127" data-mp="2k1cf4jpk1p5i">{graphic.type}</p>
                    {graphic.dimensions && <p className="text-sm opacity-80" data-id="element-7128" data-mp="254ligi79mrjl">
                        {graphic.dimensions.width}x{graphic.dimensions.height}
                      </p>}
                  </div>
                </div>
              </div>)}
          </div>}
      </div>

      {selectedGraphic && <GraphicsLightbox graphic={selectedGraphic} isOpen={!!selectedGraphic} onClose={() => setSelectedGraphic(null)} onDownload={() => console.log('Download', selectedGraphic.id)} data-id="element-7129" data-mp="yosvlezl8zt2" />}
    </div>;
};